<template>
  <div class="about">
    <h1>This is an page-1 page</h1>
    <Alert closable>mock 请求数据使用的 POST 方法</Alert>
    <div>
      <span>我和我的家乡——</span>
      <Tag color="volcano">{{ hometown }}</Tag>
    </div>
  </div>
</template>

<script>
import { getHometown } from '@/api/page-one';

export default {
  data() {
    return {
      hometown: '',
    };
  },
  methods: {
    requestData() {
      let parameters = {
        type: 1,
      };
      getHometown(parameters).then((result) => {
        this.hometown = result.data;
      });
    },
  },
  mounted() {
    this.requestData();
  },
};
</script>
